module.exports = __webpack_public_path__ + "img/北京体育大学@2x.3c42ac63.png";